import * as React from "react";
import { Redirect } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import withServices from "../../../../HOCs/withServices";
import NavBar from "../../../../components/CustomNav/CustomNav.Component";
import DatePicker from "../../../../components/DatePicker/DatePickerComponent";
import parentBg from "../../../../assets/images/parentreg/parentreg-bg.jpg";

import {
  Container,
  FormContainer,
  FormWrapper,
  CtaWrapper,
  TooltipParagraph,
  Disclaimer,
} from "../../Common/Common.styles";
import {
  // Row,
  // Section,
  // Col,
  // Heading,
  InputWrapper,
} from "../../Institution/Registration/SchoolRegistration.styles";

import {
  Row,
  Section,
  Col2,
  Heading,
} from "../../Parent/Registration/ParentRegistration.styles";

import { currentBaseUrl, saveItem } from "../../../../common/services";
import {
  CURRENTUSERID,
  CURRENTUSERNAME,
  PROFILEKEY,
  SUBSCRIPTIONKEY,
  TOKENKEY,
  CURRENTDESIGNATION,
} from "../../../../common/constants";

interface IProps {
  services?: any;
  history?: any;
  match?: any;
}

class ParentRegistrationMarketing extends React.Component<IProps> {
  public state = {
    email: "",
    phone: "",
    dateObj: null as any,
    username: "",
    password: "",
    confirmpassword: "",
    age: "",
    firstname: "",
    lastname: "",
  };
  constructor(props) {
    super(props);
    this.navigate = this.navigate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.registerParent = this.registerParent.bind(this);
  }

  public async componentDidMount() {
    const {
      history,
      services: { isUserLoggedIn, isUserUpgraded },
    } = this.props;

    if (isUserLoggedIn) {
      if (isUserUpgraded) {
        this.navigate("parents/home");
      }
    }
  }
  public handleChange(event) {
    const currentField = event.target.dataset.arg;
    this.state[currentField] = event.target.value;
    console.info(this.state[currentField]);
  }
  public ageChangeHandler = (dateObj) => {
    const age = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ dateObj, age });
  };
  public navigate(destination) {
    const { history } = this.props;
    history.push(destination);
  }

  public async registerParent(event) {
    const {
      username,
      email,
      phone,
      age,
      password,
      confirmpassword,
      firstname,
      lastname,
    } = this.state;
    const {
      services: { fixturesAPI, baseAPI, parentsAPI },
    } = this.props;
    // handle form submission
    event.preventDefault();
    const item = {
      // username,
      childdob: age,
      email,
      password,
    };
    console.info("Payload: " + JSON.stringify(item, null, 5));
    // post data and navigate on success
    const packageID = this.props.match.params.packageid;
    let regRes;
    console.log(packageID);
    if (typeof packageID === "undefined") {
      // regRes = await this.props.services.parentsAPI.registerMarketingParents(
      //   item
      // );
      //
      const item = {
        email,
        password,
        first_name: firstname,
        last_name: lastname,
        childdob: age,
        phone,
      };

      regRes = await this.props.services.parentsAPI.registerParent_v3(item);
      console.log({ regRes });
      if (regRes.ok) {
        toast.success("Account Created Successfully");

        this.props.history.replace("/login");
      } else {
        toast.error("Sign up failed, check your details!");
      }
    } else {
      alert(JSON.stringify({ ...item, selected_package: +packageID }, null, 4));
      regRes = await this.props.services.parentsAPI.registerMarketingParents({
        ...item,
        selected_package: +packageID,
      });

      console.log(regRes);
      if (regRes.ok) {
        saveItem(PROFILEKEY, regRes.data.profile);
        saveItem(SUBSCRIPTIONKEY, regRes.data.subscription);
        saveItem(TOKENKEY, regRes.data.token);
        saveItem(CURRENTDESIGNATION, regRes.data.designation);
        saveItem(PROFILEKEY, regRes.data.profile);
        saveItem(CURRENTUSERNAME, regRes.data.userinfo.username);
        saveItem(CURRENTUSERID, regRes.data.userinfo.id);
        this.props.history.push(
          `${currentBaseUrl()}purchase${typeof packageID === "undefined" ? "" : "/" + packageID
          }`
        );
      } else {
        toast.error("Sign up failed, check your details!");
      }
    }
  }

  public render() {
    const packageID = this.props.match.params.packageid;

    return (
      <Container background={parentBg}>
        <ToastContainer />
        <NavBar />
        <Section
          backgroundImage="linear-gradient(45deg, rgba(172, 255, 36, 0.8), rgba(62, 233, 247, 0.8))"
          height="100%"
          justify="center"
        >
          <Row
            style={{ maxWidth: "1024px", boxShadow: "10px 10px 64px #0a0a0a" }}
            wrap={true}
            width="80%"
            justify="center"
          >
            <Col2
              height={typeof packageID === "undefined" ? "840px" : "540px"}
              background={parentBg}
            >
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundColor: "#00000085",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-end",
                  padding: "2em",
                  minWidth: "400px",
                }}
              >
                <Heading style={{ textAlign: "left" }}>
                  It's time for you to register.
                </Heading>
              </div>
            </Col2>
            <Col2 height={typeof packageID === "undefined" ? "840px" : "540px"}>
              <FormContainer>
                <FormWrapper width="100%">
                  {/* <img className="logo" src={logo} alt="PLEX" /> */}
                  <p
                    style={{
                      textAlign: "left",
                      fontSize: "24px",
                      width: "100%",
                      padding: "0 16px",
                    }}
                    className="designation-title"
                  >
                    Sign up to continue
                  </p>
                  <form onSubmit={this.registerParent}>
                    {/* <h2 className="form-header">REGISTER YOUR DETAILS</h2> */}
                    {/* <div className="fields-wrapper"> */}
                    <InputWrapper>
                      <p>EMAIL <span style={{ fontSize: "14px", color: "#666" }}>(This will be your login username)</span></p>
                      <input
                        type="email"
                        id="email"
                        className="custom-textfield"
                        placeholder="Enter your email address"
                        required={true}
                        data-arg="email"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>
                    {typeof packageID === "undefined" ? (
                      <>
                        <InputWrapper>
                          <p>First Name</p>
                          <input
                            type="text"
                            id="firstname"
                            className="custom-textfield"
                            placeholder="Enter your first name"
                            required={true}
                            data-arg="firstname"
                            onChange={this.handleChange}
                          />
                        </InputWrapper>
                        <InputWrapper>
                          <p>Last Name</p>
                          <input
                            type="text"
                            id="lastname"
                            className="custom-textfield"
                            placeholder="Enter your last name"
                            required={true}
                            data-arg="lastname"
                            onChange={this.handleChange}
                          />
                        </InputWrapper>
                        <InputWrapper>
                          <p>Phone Number</p>
                          <input
                            type="tel"
                            id="phone"
                            className="custom-textfield"
                            placeholder="Enter your phone number"
                            required={true}
                            data-arg="phone"
                            onChange={this.handleChange}
                          />
                        </InputWrapper>
                      </>
                    ) : (
                      <></>
                    )}


                    <InputWrapper>
                      <TooltipParagraph>
                        PASSWORD <a href="#">Password requirements</a>
                        <span className="hover-tooltip">
                          Your password must be at least 8 characters long and contain at least one letter and one number.
                        </span>
                      </TooltipParagraph>
                      <input
                        type="password"
                        id="password"
                        className="custom-textfield"
                        placeholder="Enter a password for your account"
                        required={true}
                        data-arg="password"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>
                    <InputWrapper>
                      <TooltipParagraph>
                        CHILD DOB <a href="#">Why do we need this?</a>
                        <span className="hover-tooltip">
                          Performance Learning’s assessments are tailored to
                          your child’s age hence why we ask this question
                        </span>
                      </TooltipParagraph>
                      <DatePicker
                        value={this.state.dateObj}
                        onChange={this.ageChangeHandler}
                      />
                    </InputWrapper>
                    {/* </div> */}



                    <CtaWrapper>
                      <button
                        style={{ color: "#000", width: "100%" }}
                        className="green-button register-parent"
                        type="submit"
                      >
                        Register
                      </button>
                    </CtaWrapper>
                    <span style={{ fontSize: "13px", textAlign: "center", width: "100%" }}>After successful registration you will be taken to the login page to login and get set up.</span>

                    <Disclaimer>By registering you agree to our <a href="https://myperformancelearning.com/privacy-policy/" target="_blank">Privacy Policy</a>, <a href="http://myperformancelearning.com/cookie-policy/" target="_blank">Cookie Policy</a> and <a href="/terms-of-use" target="_blank">Terms of Use</a>.</Disclaimer>
                    <p className="already-registered">
                      ALREADY REGISTERED?{" "}
                      <span onClick={this.navigate.bind(this, "login")}>
                        LOGIN HERE
                      </span>
                    </p>
                  </form>
                </FormWrapper>
              </FormContainer>
            </Col2>
          </Row>
        </Section>
      </Container>
    );
  }
}

export default withServices(ParentRegistrationMarketing);



// WEBPACK FOOTER //
// ./src/pages/Onboard/Parent/Registration/ParentRegistrationMarketing.tsx